<app-azara-wrapper data-cy="centers-wrapper">
    <form #centerSelector (submit)="onSubmit($event)" data-cy="center-selector-form">
        <ul class="app-form__list" data-cy="form-list">
            <li class="app-form__list__item" data-cy="center-selection-item">
                <label class="app-form__label" for="Selected" data-cy="center-selection-label">
                    Please select a Center to continue
                </label>
                <select
                    required
                    [(ngModel)]="scopedCenter"
                    class="form-control"
                    data-val="true"
                    data-val-range="Center must be selected"
                    data-val-range-max="2147483647"
                    data-val-range-min="1"
                    data-val-required="The Selected field is required."
                    id="Selected"
                    name="Selected"
                    data-cy="center-select"
                >
                    <option disabled selected value="null" data-cy="center-placeholder-option">
                        Please select a Center
                    </option>
                    @for (center of centers(); track center.id) {
                        <option [ngValue]="center" [attr.data-cy]="'center-option-' + center.id">
                            {{ center.name }}
                        </option>
                    }
                </select>
            </li>
            <li class="app-form__list__item" data-cy="submit-button-item">
                <button
                    class="btn btn-block btn-primary"
                    name="button"
                    value="login"
                    type="submit"
                    data-cy="center-select-btn"
                >
                    Select
                </button>
            </li>
        </ul>
    </form>
</app-azara-wrapper>
